module.exports = __webpack_public_path__ + "media/images/success-icon-1218fa2a.png";